import React, { useEffect, useState, useRef } from 'react'
import axios from './../../services/Api';
import { useForm } from 'react-hook-form'
import http from './../../services/Api'
import swal from 'sweetalert';

import Logo from './../../assets/img/ares-logo.png'
import './index.css';

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { RiLoader4Line } from 'react-icons/ri';
import { Col, Row } from 'react-bootstrap';

export default function Register({ history, location }) {
    const query = new URLSearchParams(location.search)
    const planId = query.get('plan_id');
    // const cicleId = query.get('cicle_id');

    const { register, handleSubmit, errors, watch } = useForm();
    const [loading, setLoading] = useState(false);
    // const [plan, setPlan] = useState(null);
    // const [plans, setPlans] = useState([])
    const password = useRef({});
    password.current = watch("password", "");

    useEffect(() => {
        getPlan()
        getPlans();
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const verifyEmail = async email => {
        try {
            let response = await http.post(`/api/user/email-available`, { 'email': email });
            return response;
        } catch (e) {
            console.log(e)
            return e;
        }
    }

    const save = async data => {
        const { name, username, email, phone, password } = data;
        setLoading(true)

        try {
            const response = await verifyEmail(email)
            if (!response.data) {
                try {
                    await http.post(`/api/client`, {
                        name,
                        username,
                        email,
                        phone,
                        password,
                        client: { name }
                    });
                    swal("Cadastro concluído com sucesso!",
                        {
                            title: "Sucesso!",
                            buttons: {
                                login: {
                                    text: "Ir para o Login",
                                    value: "login",
                                },
                            },
                            icon: "success",
                        })
                        .then((value) => {
                            if (value === 'login') {
                                history.push('/login');
                            }
                        });
                    setLoading(false);
                } catch (e) {
                    console.log(e)
                    setLoading(false);
                }
            } else {
                swal('Erro!', "Email já cadastrado no sistema", "error")
                setLoading(false);
            }
        } catch (e) {
            setLoading(false);
            console.log(e)
        }
    }


    async function getPlan() {
        try {
           await axios.get('/api/plans/' + planId);
            // setPlan(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    async function getPlans() {
        try {
            await axios.get('/api/plans');
            // setPlans(response.data);
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div className="Register">
            <div className="content">
                <div className="left">
                    <div className="container-img">
                        <img src={Logo} alt="logo" />
                    </div>
                    <div className="copyright">
                        Copyright © 2021 Synapse Brasil, Inc.
                         </div>
                </div>

                <div className="right">
                    <Form method="POST" onSubmit={handleSubmit(save)}>
                        <div className="text-center">
                            <h1>Cadastre-se</h1>
                        </div>
                        <Form.Group>
                            <Form.Control type="text" placeholder="Nome" name="name" ref={register} required />
                        </Form.Group>

                        <Form.Group>
                            <Form.Control type="text" placeholder="Usuário" name="username" ref={register} required />
                        </Form.Group>

                        <Form.Group>
                            <Form.Control type="email" placeholder="Email" name="email" ref={register} required />
                            <Form.Text className="text-muted">
                                Nunca vamos compartilhar seu email com ninguém.
                            </Form.Text>
                        </Form.Group>

                        <Form.Group>
                            <Form.Control type="text" placeholder="Telefone" name="phone" ref={register} required />
                        </Form.Group>
                        <Form.Group name="password" controlId="password">
                            <Form.Control
                                name="password"
                                placeholder="Digite sua Senha"
                                type="password"
                                ref={register({
                                    required: "Você deve escolher uma senha",
                                    minLength: {
                                        value: 8,
                                        message: "A senha deve ter no mínimo 8 caracteres"
                                    },
                                    pattern: {
                                        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
                                        message: "A senha deve conter ao menos um caractere maiúsculo e um caractere especial"
                                    }
                                })} />
                            <span className="form-error-register">
                                {errors.password && <p>{errors.password.message}</p>}
                            </span>
                        </Form.Group>
                        <Form.Group controlId="confirmPassword">
                            <Form.Control
                                name="password_repeat"
                                type="password"
                                placeholder="Confirme sua Senha"
                                ref={register({
                                    validate: value =>
                                        value === password.current || "As senhas devem ser iguais"
                                })} />
                            <span className="form-error-register">
                                {errors.password_repeat && <p>{errors.password_repeat.message}</p>}
                            </span>
                        </Form.Group>
                        <Row>
                            <Col>
                                <Button variant="default" type="button" onClick={() => {
                                    history.push('/login');
                                }}>
                                    Voltar
                                </Button>
                            </Col>
                            <Col>
                                <Button variant="primary" type="submit">
                                    {loading ? (<RiLoader4Line className="spin" />) : 'Cadastrar'}
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <p className="terms-alert">Ao cadastrar-se você está concordando com os <a href="https://terms.guiadobem.com.br/">termos de serviço</a></p>
                </div>
            </div>
        </div>
    )
}